export default __webpack_public_path__ + "static/media/icn-user.7c333a5e.svg";